import * as React from 'react';
import { ArticleParagraph1, UIHeading4 } from '@cian/ui-kit';

import * as styles from './styles.css';

interface IProsAndCons {
  title: string;
  subtitle?: string;
  pros: React.ReactNode;
  cons: React.ReactNode;
}

export const ProsAndCons = ({ title, subtitle, pros, cons }: IProsAndCons) => {
  return (
    <div className={styles['container']}>
      <div className={styles['title']}>
        <UIHeading4>{title}</UIHeading4>
      </div>
      {subtitle && <ArticleParagraph1 color="gray60_100">{subtitle}</ArticleParagraph1>}
      <div className={styles['textfield']}>{pros}</div>
      <div className={styles['textfield']}>{cons}</div>
    </div>
  );
};
